export const texts = {
    h: {
        noConnectionTitle: 'אין חיבור לאינטרנט',
        noConnectionContent: 'ברגע שהחיבור לאיטרנט יתחדש, פריוריטי תמשיך לעבוד',
        mainButton: 'התחברתי',
        stillNoConnection: 'עדיין אין חיבור לאינטרנט.',
        checkAgain: 'כדאי לבדוק את החיבור ולנסות שוב.',
        confirm: 'אישור'
    },
    e: {
        noConnectionTitle: 'No internet connection',
        noConnectionContent: 'As soon as the internet is reconnected, Priority will',
        mainButton: "I'm connected",
        stillNoConnection: "There's still no internet connection.",
        checkAgain: 'Check the connection and try again.',
        confirm: 'OK'
    }
};
